import React from "react";
import { DataGrid, FilterRow, Column } from "devextreme-react/data-grid";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarIndicesTrimapDs } from "../DataSources.js";

export default class IndicesTrimap extends React.Component {
  constructor() {
    super();

    this.indicesTrimapDs = criarIndicesTrimapDs();
  }


  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar titulo="Índices Trimap" ocultarNovo={true}>
          <DataGrid
            dataSource={this.indicesTrimapDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            focusedRowEnabled={true}
            wordWrapEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <FilterRow visible={true} />
            <Column
              dataField={"nomeOficial"}
              caption={"Índice"}
              width={"150"}
            />
            <Column dataField={"frequencia"} />
            <Column dataField={"orgao"} caption={"Órgão"} />
            <Column dataField={"link"} />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }
}
